import Vue from 'vue';
import Vuex from 'vuex';
import secureStorage from '../controllers/secureStorage.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loggedIn: secureStorage.getItem("loggedIn"),
        currentProfile: "",
        currentApiURL: process.env.VUE_APP_API_URL,
        endPoint: process.env.VUE_APP_END_POINT,
        publicUrl: process.env.VUE_APP_PUBLIC_URL,
        // currentApiURL: "http://localhost:3026/api/v2/brands",
        // endPoint: "http://localhost:3026/api/v2/",
        // publicUrl: "http://localhost:3026/",
        // currentApiURL: "https://hq.bxi.world:8086/api/v2/brands",
        // endPoint: "https://hq.bxi.world:8086/api/v2/",
        // publicUrl: "https://hq.bxi.world:8086/",
        userEmail: "",
        profileId: 0,
        parentId: 0,
        parameters: "",
        serverType: 'ho',
        validSites: [],
        selectedSite: "",
        categoriesOptions: [],
        selectedWavelet: null,
        enabledCategories: [],
        enabledCategoryUrls: [],
        // defaultSite: 0
    },

    getters: {

    },

    mutations: {
        // Nav Mutations
        updateLoggedInStatus(state, value) {
            state.loggedIn = value
        },
        updateCurrentProfile(state, value) {
            state.currentProfile = value;
            state.currentApiURL = state.endPoint + value
        },
        updateCurrentApiURL(state, value) {
            state.currentApiURL = state.endPoint + value
        },
        updateUserEmail(state, value) {
            state.userEmail = value;
        },
        updateProfileId(state, value) {
            state.profileId = value;
        },
        updateSelectedWavelet(state, value) {
            state.selectedWavelet = value;
        },
        updateParameters(state, value) {
            state.parameters = value
        },
        updateParentId(state, value) {
            state.parentId = value
        },
        updateServerType(state, value) {
            state.serverType = value
        },
        updateValidSites(state, value) {
            state.validSites = value
        },
        updateSelectedSite(state, value) {
            state.selectedSite = value
        },
        updateCategoriesOptions(state, value) {
            state.categoriesOptions = value
        },
        updateEnabledCategories(state, value) {
            state.enabledCategories = value
        },
        updateEnabledCategoryUrls(state, value) {
            state.enabledCategoryUrls = value
        },
    },

    actions: {
        // Nav Actions
        updateLoggedInStatus(context, value) {
            context.commit('updateLoggedInStatus', value)
        },
        updateCurrentProfile(context, value) {
            context.commit('updateCurrentProfile', value)
        },
        updateCurrentApiURL(context, value) {
            context.commit('updateCurrentApiURL', value)
        },
        updateUserEmail(context, value) {
            context.commit('updateUserEmail', value)
        },
        updateProfileId(context, value) {
            context.commit('updateProfileId', value)
        },
        updateSelectedWavelet(context, value) {
            context.commit('updateSelectedWavelet', value)
        },
        updateParameters(context, value) {
            context.commit('updateParameters', value)
        },
        updateParentId(context, value) {
            context.commit('updateParentId', value)
        },
        updateServerType(context, value) {
            context.commit('updateServerType', value)
        },
        updateValidSites(context, value) {
            context.commit('updateValidSites', value)
        },
        updateSelectedSite(context, value) {
            context.commit('updateSelectedSite', value)
        },
        updateCategoriesOptions(context, value) {
            context.commit('updateCategoriesOptions', value)
        },
        updateEnabledCategories(context, value) {
            context.commit('updateEnabledCategories', value)
        },
        updateEnabledCategoryUrls(context, value) {
            context.commit('updateEnabledCategoryUrls', value)
        }
    }

});
